<template>
  <div id="course">
    <section class="course-title-container">
      <div class="course-dashboard">
        <template v-if="loading">
          <v-card class="rounded-xl mt-5">
            <v-skeleton-loader type="article"></v-skeleton-loader>
          </v-card>
          <div class="dash-line mt-5">
            <div class="cta-stats-column">
              <v-skeleton-loader
                class="rounded-xl"
                style="width: 360px; height: 84px"
                type="image"
              ></v-skeleton-loader>
              <v-skeleton-loader
                class="rounded-xl"
                style="width: 360px; height: 84px"
                type="image"
              ></v-skeleton-loader>
            </div>
            <v-skeleton-loader
              class="rounded-xl"
              style="width: 360px; height: 184px"
              type="image"
            ></v-skeleton-loader>
          </div>
        </template>

        <template v-else>
          <div class="course-header">
            <h1 style="line-height: 1.1">{{ this.course.course }}</h1>
            <div v-if="!$vuetify.breakpoint.xs" class="text-h6">
              {{ this.course.description }}
            </div>
          </div>
          <div class="dash-line">
            <div
              :class="{
                'cta-stats-column': course.certification_id !== null,
                'full-width-row': course.certification_id === null,
              }"
            >
              <div
                class="stats"
                :style="{
                  'min-height':
                    $vuetify.breakpoint.smAndDown ||
                    course.certification_id === null
                      ? '100px'
                      : '200px',
                }"
              >
                <div class="aulas-assistidas">
                  <span class="span-enfase">Aulas assistidas:</span>
                  <span
                    class="enfase"
                    style="min-width: 70px; max-width: 70px; text-align: center"
                    >{{ this.dashboard.aulasAssistidas }}</span
                  >
                </div>
                <div
                  v-if="
                    $vuetify.breakpoint.width <= 695 ||
                    $vuetify.breakpoint.width >= 840
                  "
                  style="
                    border-left: var(--v-primary-base) solid 1px;
                    height: 50px;
                    margin: 4px 20px;
                  "
                ></div>
                <div
                  v-if="
                    $vuetify.breakpoint.width <= 695 ||
                    $vuetify.breakpoint.width >= 840
                  "
                  class="mock-numbers"
                >
                  <span style="font-size: 32px; font-weight: 500">{{
                    this.dashboard.aulasAssistidasSemana
                  }}</span>
                  <span class="text-center-420">Esta semana</span>
                </div>
              </div>
            </div>
            <div
              v-if="course.certification_id !== null"
              class="stats"
              :style="
                $vuetify.breakpoint.xs ? 'max-width: 100%' : 'max-width: 367px'
              "
            >
              <div class="mock-stats">
                <span class="mb-3">Você nos simulados:</span>
                <div style="display: flex; align-items: center">
                  <div class="mock-numbers">
                    <span style="font-size: 32px; font-weight: 500"
                      >{{ this.dashboard.aproveitamento }}%</span
                    >
                    <span>Aproveitamento</span>
                  </div>
                  <div
                    style="
                      border-left: var(--v-primary-base) solid 1px;
                      height: 50px;
                      margin: 4px 20px;
                    "
                  ></div>
                  <div class="mock-numbers">
                    <span style="font-size: 32px; font-weight: 500">{{
                      this.dashboard.resolvidas
                    }}</span>
                    <span>Resolvidas</span>
                  </div>
                  <div
                    v-if="$vuetify.breakpoint.width >= 400"
                    style="
                      border-left: var(--v-primary-base) solid 1px;
                      height: 50px;
                      margin: 4px 20px;
                    "
                  ></div>
                  <div
                    v-if="$vuetify.breakpoint.width >= 400"
                    class="mock-numbers"
                  >
                    <span style="font-size: 32px; font-weight: 500">{{
                      this.dashboard.acertos
                    }}</span>
                    <span>Acertos</span>
                  </div>
                </div>
                <div
                  style="display: flex; align-items: baseline; margin-top: 15px"
                >
                  <span class="span-enfase">Melhor aproveitamento:</span>
                  <span class="enfase">{{
                    this.dashboard.melhorAproveitamento
                  }}</span
                  ><span>%</span>
                </div>
              </div>
            </div>
          </div>

          <div id="aprovacao" v-if="course.certification_id !== null">
            <div class="explanation">
              <div
                class="mb-3"
                style="
                  display: flex;
                  flex-wrap: nowrap;
                  align-items: center;
                  gap: 10px;
                "
              >
                <h3 class="probabilidade-title">Probabilidade de Aprovação</h3>
                <v-menu
                  :close-on-content-click="false"
                  :nudge-width="200"
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on">info_outline</v-icon>
                  </template>
                  <v-card max-width="300" class="pa-4">
                    {{ this.statusInfo }}
                  </v-card>
                </v-menu>
              </div>
              <span class="grey--text">{{
                this.dashboard.statusDescription
              }}</span>
            </div>
            <div class="progress">
              <div class="progress-status my-4">
                <div class="stage">
                  <span
                    v-if="statusActive === 1"
                    class="span-status rounded-pill px-5 mb-4"
                    style="
                      background-color: #ffcdd2;
                      color: #c62828;
                      margin-left: 27px;
                    "
                  >
                    Improvável
                  </span>
                </div>
                <div class="stage">
                  <span
                    v-if="statusActive === 2"
                    class="span-status rounded-pill px-5 mb-4"
                    style="background-color: #ffe0b2; color: #ef6c00"
                  >
                    Pouco provável
                  </span>
                </div>
                <div class="stage">
                  <span
                    v-if="statusActive === 3"
                    class="span-status rounded-pill px-5 mb-4"
                    style="background-color: #fff9c4; color: #f9a825"
                  >
                    Provável
                  </span>
                </div>
                <div class="stage">
                  <span
                    v-if="statusActive === 4"
                    class="span-status rounded-pill px-5 mb-4"
                    style="
                      background-color: #c8e6c9;
                      color: #2e7d32;
                      margin-left: -25px;
                    "
                  >
                    Muito provável
                  </span>
                </div>
              </div>
              <div class="progress-bar">
                <div
                  class="custom-circle"
                  :style="`--user-probability: ${userProbability}%;`"
                ></div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </section>
    <div class="mt-5" style="margin-bottom: 50px">
      <!-- Seção dos botões quadrados dinâmicos -->
      <v-card v-if="loading" class="rounded-xl pa-5 pt-10">
        <v-skeleton-loader
          v-for="i in 4"
          type="text"
          class="my-8"
        ></v-skeleton-loader>
      </v-card>
      <v-card
        v-else
        class="rounded-xl"
        style="margin-bottom: 40px; box-shadow: none"
      >
        <v-row class="equal-height-row">
          <v-col
            v-for="(button, index) in availableButtons"
            :key="index"
            :cols="buttonCols"
            :md="buttonMdCols"
            class="d-flex justify-center"
            style="padding: 8px !important"
          >
            <v-card
              :class="['action-button', 'text-center', 'pa-4', 'shortcut']"
              hover
              @click="button.action"
            >
              <v-icon
                :size="$vuetify.breakpoint.xs ? 30 : 40"
                color="var(--v-primary-base)"
                class="mb-2"
                >{{ button.icon }}</v-icon
              >
              <div
                :class="buttonCols === 4 ? 'text-subtitle-2' : 'text-h6'"
                class="mb-1"
                style="color: var(--v-primary-base); flex-grow: 0"
              >
                {{ button.title }}
              </div>
              <div
                v-if="!$vuetify.breakpoint.xs"
                class="text-caption grey--text"
                style="flex-grow: 1"
              >
                {{ button.description }}
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
      <!-- complex chart -->
      <v-layout row wrap> </v-layout>
    </div>
    <AITools
      ref="ai"
      :course-id="parseInt(course.id)"
      :preparation-stage="parseInt(statusActive)"
      :guide-assistant="course.learning_guide_assistant"
      :chat-assistant="course.chat_assistant"
      :is-guide-chat="true"
      @resourceAvailable="chatAvailable = $event"
    />
  </div>
</template>

<script>
import Material from "vuetify/es5/util/colors";
import CourseService from "../../services/courses.service";
import AITools from "../../components/aiTools/AITools.vue";

export default {
  components: {
    AITools,
  },
  mounted() {
    window.addEventListener("offline", () => {
      this.isOffline = true;
    });
    window.addEventListener("online", () => {
      this.isOffline = false;
    });
  },
  data() {
    return {
      chatAvailable: false,
      isOffline: !navigator.onLine,
      color: Material,
      course: {},
      loading: true,
      showBannerReview: false,
      reviewKey: null,
      courseStarted: true,
      actualDialogDelayInDays: 10,
      userProbability: null,
      statusActive: null,
      dashboard: {
        aulasAssistidas: 0,
        aulasAssistidasSemana: 0,
        resolvidas: 0,
        acertos: 0,
        aproveitamento: 0,
        melhorAproveitamento: 0,
        statusDescription: "",
      },
    };
  },
  computed: {
    availableButtons() {
      const buttons = [];

      let courseStarted =
        (this.course?.user_progress?.total_watched_items ?? 0) > 0;
      buttons.push({
        icon: "play_arrow",
        title: courseStarted ? "Continuar" : "Começar",
        description: courseStarted
          ? "Continue de onde parou"
          : "Comece a assistir as aulas",
        action: this.continueCourse,
      });

      if (this.chatAvailable) {
        buttons.push({
          icon: "chat",
          title: "SharkGPT",
          description: "Nossa IA para tirar suas dúvidas",
          action: this.navigateToSharkGpt,
        });
      }

      if (this.course?.available_resources?.has_lessons ?? false) {
        buttons.push({
          icon: "video_library",
          title: "Aulas",
          description: "Assista todas as aulas",
          action: this.navigateToClasses,
        });
      }

      if (this.course?.available_resources?.has_podcasts ?? false) {
        buttons.push({
          icon: "headset",
          title: "Podcast",
          description: "Ouça o podcast sobre o conteúdo da aula",
          action: this.navigateToPodcast,
        });
      }

      return buttons;
    },

    buttonCols() {
      const buttonCount = this.availableButtons.length;
      if (buttonCount === 2) return 6;
      if (buttonCount === 3) return 4;
      return 6;
    },

    buttonMdCols() {
      const buttonCount = this.availableButtons.length;
      if (buttonCount === 2) return 6;
      if (buttonCount === 3) return 4;
      return 3;
    },
  },

  metaInfo() {
    return {
      title:
        this.course != null ? "LS - Curso " + this.course.course : "LS - Curso",
      meta: [
        {
          vmid: "description",
          name: "description",
          content:
            this.course != null
              ? "LS - Curso " + this.course.description
              : "Curso preparatório para certificações financeiras",
        },
      ],
    };
  },
  created() {
    this.loadCourse();
    this.reviewKey = "review-" + this.$route.params.courseId;
  },
  methods: {
    isMobile() {
      return this.$vuetify.breakpoint.xs;
    },

    loadCourse() {
      let totalRequests = 0;
      let totalFinishedRequests = 0;
      totalRequests++;
      CourseService.getCourseById(
        this.$route.params.courseId,
        "available_resources,user_progress",
      )
        .then((response) => {
          this.course = response.data;
          this.metaInfo.titleTemplate = "%s - Curso " + this.course.course;
          this.$store.dispatch("changeCourse", this.course);
          this.checkCourseReview();
          totalFinishedRequests++;
          this.stopMainLoading(totalRequests, totalFinishedRequests);
        })
        .catch((err) => {
          const res = err.res;
          if (err.status === 404 || err.status === 403) {
            this.$router.push("/courses");
          }
          totalFinishedRequests++;
          this.stopMainLoading(totalRequests, totalFinishedRequests);
        });

      totalRequests++;
      CourseService.getDashboard(this.$route.params.courseId)
        .then((response) => {
          this.dashboard.aulasAssistidas = response.itemsWatched;
          this.dashboard.aulasAssistidasSemana = response.itemsWatchedByRange;
          this.dashboard.resolvidas = response.questions;
          this.dashboard.acertos = response.questionsCorrect;
          this.dashboard.aproveitamento = response.averageScore;
          this.dashboard.melhorAproveitamento = response.score;
          this.dashboard.statusDescription = response.statusDescription;
          this.statusActive = response.statusActive;
          this.userProbability = response.probability;
          this.statusInfo = response.statusInfo;
          totalFinishedRequests++;
          this.stopMainLoading(totalRequests, totalFinishedRequests);
        })
        .catch((err) => {
          console.log(err);
          totalFinishedRequests++;
          this.stopMainLoading(totalRequests, totalFinishedRequests);
        });
    },

    stopMainLoading(totalRequests, totalFinishedRequests) {
      if (totalRequests <= totalFinishedRequests) {
        this.loading = false;
      }
    },

    continueCourse() {
      this.loading = true;
      CourseService.getLastItem(this.$route.params.courseId)
        .then((response) => {
          if (response.data !== null) {
            this.loading = false;
            this.$router.push({
              name: "classroom",
              params: {
                courseId: this.$route.params.courseId,
                sectionItemId: response.data.course_section_item_id,
                slug: response.data.slug,
              },
            });
          } else {
            this.loading = false;
            window.getApp.sendSnackMessage("Curso sem aulas", "error");
          }
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          if (this.isOffline) {
            window.getApp.sendSnackMessage(
              "Primeiro acesse esse conteúdo com internet para que possa ficar disponível offline",
              "error",
            );
          }
        });
    },
    checkCourseReview() {
      // console.log(this.course)
      if (!this.course.review_available) return;
      let review = localStorage.getItem(this.reviewKey);
      if (review !== null) review = new Date(review);
      const today = new Date();
      if (review == null || review < today) {
        this.showBannerReview = true;
      }
    },

    navigateToSharkGpt() {
      this.$refs.ai.handleOptionClickFromShortcut();
    },
    navigateToClasses() {
      this.$router.push({
        name: "course",
        params: {
          courseId: this.$route.params.courseId,
          slug: this.$route.params.slug,
        },
      });
    },
    navigateToPodcast() {
      this.$router.push({
        name: "course",
        params: {
          courseId: this.$route.params.courseId,
          slug: this.$route.params.slug,
        },
        hash: "#podcast",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#course {
  max-width: 770px;
  margin: 0 auto;
  @media screen and (max-width: 1040px) {
    margin: 0 5%;
  }
}
.course-dashboard {
  display: flex;
  flex-direction: column;
}
.course-header {
  position: relative;
  padding: 10px 22px;
  margin-top: 16px;
  border-radius: 20px;
  color: white;
  margin-bottom: 16px;
  z-index: 1;
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(
      135deg,
      black 0%,
      black 65%,
      var(--v-primary-darken2) 66%,
      var(--v-primary-darken2) 75%,
      var(--v-primary-darken1) 76%,
      var(--v-primary-darken1) 85%,
      var(--v-primary-base) 86%,
      var(--v-primary-base) 100%
    );
    z-index: -1;
    border-radius: 20px;
    pointer-events: none;
  }
}
.dash-line {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  @media screen and (min-width: 1000px) {
    flex-wrap: nowrap;
  }
  flex-wrap: wrap;

  .stats {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 22px;
    line-height: 1.1;
    color: var(--v-primary-base);
    border-radius: 20px;
    width: 100%;
    @media screen and (max-width: 600px) {
      min-height: 100px;
    }
    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: var(--v-primary-base);
      opacity: 0.2;
      z-index: 0;
      border-radius: 20px;
      pointer-events: none;
    }
  }
  .cta {
    @extend .stats;
    justify-content: space-around;
    background-color: var(--v-primary-base);
    color: white !important;
    font-size: 24px;
    padding: 16px;
    height: 83px;
    width: 100%;
    cursor: pointer;
    &::before {
      display: none;
    }
  }
  .cta-nao-preparatorio {
    @extend .stats;
    width: 368px;
    height: 102px;
    justify-content: space-around;
    background-color: var(--v-primary-base);
    color: white !important;
    font-size: 24px;
    @media screen and (max-width: 600px) {
      width: 100%;
    }
  }
  .cta-stats-column {
    display: flex;
    flex-direction: column;
    gap: 16px;
    @media screen and (max-width: 600px) {
      width: 100%;
    }
  }
  .full-width-row {
    width: 100%;
    .stats {
      height: 100px;
    }
  }
  .mock-stats {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
  }
  .mock-numbers {
    display: flex;
    flex-direction: column;
    align-items: center;
    line-height: 1;
  }
  .aulas-assistidas {
    display: flex;
    align-items: baseline;
    @media screen and (max-width: 420px) {
      align-items: center;
    }
  }
  .enfase {
    font-size: 50px;
    font-weight: 500;
    margin-left: 5px;
    @media screen and (max-width: 500px) {
      font-size: 40px;
    }
    @media screen and (max-width: 390px) {
      font-size: 35px;
    }
  }
  .span-enfase {
    white-space: nowrap;
    font-size: 20px;
    @media screen and (max-width: 420px) {
      white-space: wrap;
    }
  }
  .text-center-420 {
    white-space: nowrap;
    @media screen and (max-width: 420px) {
      text-align: center;
      white-space: wrap;
    }
  }
}
#aprovacao {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  @media (max-width: 770px) {
    flex-direction: column;
    align-items: flex-start;
  }
  .explanation {
    max-width: 380px;
  }
  .progress {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
}
.progress-status {
  height: 15px;
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  .stage {
    min-width: 25%;
    display: flex;
    justify-content: center;
    align-items: center;
    .span-status {
      font-size: 16px;
      white-space: nowrap;
      z-index: 1;
    }
  }
}
.progress-bar {
  height: 15px;
  width: 100%;
  background: linear-gradient(
    to right,
    #e57373 0%,
    #e57373 25%,
    #ffb74d 25%,
    #ffb74d 50%,
    #fff176 50%,
    #fff176 75%,
    #81c784 75%,
    #81c784 100%
  );
  border-radius: 7.5px;
}
.probabilidade-title {
  white-space: nowrap;
  @media (max-width: 370px) {
    font-size: 22px;
  }
}
.custom-circle {
  position: relative;
  top: -2px;
  left: calc(var(--user-probability, 50%) - 3%);
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: white;
  border: 3px solid blue;
}

.shortcut {
  width: 100% !important;
  min-height: 120px !important;
  cursor: pointer !important;
  border-radius: 20px !important;
  color: var(--v-primary-base);
  display: flex;
  flex-direction: column;
  justify-content: flex-start; /* Alinha o conteúdo ao topo */
  align-items: center;
  padding-top: 16px; /* Adiciona padding para o conteúdo não colar no topo */
  padding-bottom: 16px; /* Adiciona padding para o conteúdo não colar na base */
  height: 100%; /* Garante que o botão ocupe toda a altura disponível na coluna */
  @media screen and (max-width: 420px) {
    min-height: 100px !important;
  }
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: var(--v-primary-base);
    opacity: 0.2;
    z-index: 0;
    border-radius: 20px;
    pointer-events: none;
  }

  .equal-height-row {
    display: flex;
    flex-wrap: wrap;
  }

  .equal-height-row .col {
    display: flex;
    flex-direction: column;
  }

  .equal-height-row .shortcut {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
}
</style>
